module.exports = __webpack_public_path__ + "fonts/manrope-semibold.b9eb20ae.woff2";